import { Component, inject, model, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PassaggioConsegneResponse } from './models/passaggio-consegne.model';
import { PassaggioConsegneService } from './services/passaggio-consegne.service';

@Component({
  selector: 'app-passaggio-consegne',
  template:`
      <div class="card card-w-title">
        <form [formGroup]="searchForm" (ngSubmit)="search()">
            <div class="grid">
              <div class="col-12">
                <app-date-filter formControlName="dataPassaggio" label="Data Passaggio Consegne"></app-date-filter>
              </div>        
            
              <div class="col-12 buttons flex justify-content-end">
                <button pButton type="button" icon="fas fa-search" label="Cerca" title="Cerca" (click)="search()" class="mr-2"></button>            
              </div>
            </div>
        </form>
      </div>

      <div class="card">
        <div class="grid">
          <div class="col-12 buttons flex justify-content-start">
            <button pButton type="button" icon="fas fa-people-carry" label="Nuovo Passaggio" title="Nuovo Passaggio" (click)="openAggiunta()" class="mr-2" severity="danger"></button>
          </div>    
          <div class="col-12">
            <app-passaggio-consegne-display-items [items]="items()" (print)="show($event)"></app-passaggio-consegne-display-items>
          </div>
        </div>
      </div>

      <app-passaggio-aggiunta-dialog [(isOpen)]="openPassaggioDialog" (isAdded)="addedPassaggio($event)"></app-passaggio-aggiunta-dialog>
      <app-passaggio-download-modulo-dialog [(isOpen)]="openStampaDialog" [passaggioConsegne]="passaggioConsegne()"></app-passaggio-download-modulo-dialog>  
  `
})
export class PassaggioConsegneComponent {

  private readonly fb = inject(FormBuilder);
  private readonly passaggioConsegneService = inject(PassaggioConsegneService)
  
  public openPassaggioDialog = model<boolean>(false);
  public openStampaDialog = model<boolean>(false);
  public passaggioConsegne = signal<PassaggioConsegneResponse | undefined>(undefined);

  public searchForm: FormGroup;

  public items = signal<PassaggioConsegneResponse[]>([]);

  constructor() { 
    this.searchForm = this.fb.group({
      dataPassaggio: new FormControl<Date[]|undefined>(undefined),
    });
  }

  public openAggiunta(): void {
    this.openPassaggioDialog.set(true);
  }
  
  public show(event: PassaggioConsegneResponse): void {
    this.passaggioConsegne.set(event);
    this.openStampaDialog.set(true);
  }

  public search(): void {
    const value = this.searchForm.get('dataPassaggio')?.value;
    let from : Date | null = null;
    let to : Date | null = null;

    if (value) {
        from = value[0];
        to = value[1];
    }

    this.passaggioConsegneService.getAll(from, to).subscribe( res => this.items.set(res));
  }

  public addedPassaggio(added:boolean): void {
    if ( added) {
      this.search();
    }
  }
}
